export default __webpack_public_path__ + "static/media/GoNoGoResultImg.da008d56.svg";